import { SimplifiedCourseProgress } from '@/models/StudentCourseProgress';
import AsyncCourseProgressCard from './AsyncCourseProgressCard';
import { CourseFormatEnum } from '@/models/Course';
import SyncCourseProgressCard from './SyncCourseProgressCard';

type CourseProgressCardFactory = {
  courseProgress: SimplifiedCourseProgress;
};

export default function CourseProgressCardFactory({
  courseProgress,
}: CourseProgressCardFactory) {
  const asyncCategories = [
    CourseFormatEnum.EXTRA_COURSE,
    CourseFormatEnum.SELF_PACED,
  ];
  const format = courseProgress.coursePath.course.formats;
  if (format?.some(f => asyncCategories.includes(f))) {
    return <AsyncCourseProgressCard courseProgress={courseProgress} />;
  }
  return <SyncCourseProgressCard courseProgress={courseProgress} />;
}
